// extracted by mini-css-extract-plugin
export default {"page":"common_page__Dpujd","fadeInAnimation":"common_fadeInAnimation__nRaPc"};